import React from "react";
import useMediaQuery from "../hooks/useMediaQuery";
import * as Const from "./../_Const";

const ProgressSection = ({ title, subTitle }) => {
  const max375 = useMediaQuery("(max-width: 375px)");
  const max310 = useMediaQuery("(max-width: 310px)");
  const isTerminal = Const.isTerminal();

  function getFontSize() {
    let font;
    if (isTerminal) {
      font = "text-6xl";
    } else {
      if (max310) {
        font = "text-xl";
      } else if (max375) {
        font = "text-2xl";
      } else {
        font = "text-[1.88rem]";
      }
    }
    return font;
  }

  const progressCss = isTerminal ? "mt-10" : "mt-1";
  const subTitleCss = isTerminal ? "text-3xl mt-12 grid justify-self-center" : "text-xl mt-1";
  const boxCss = isTerminal ? "h-56" : "h-36";
  return (
    <div>
      <div className="container mx-auto ">
        <div className={`bg-progress mt-8 mx-6 ${boxCss}  flex flex-col justify-center items-center`}>
          <p className={`${getFontSize()} text-accent-dark uppercase`}>{title}</p>
          <svg className={`animate-spin ${progressCss}`} xmlns="http://www.w3.org/2000/svg" width="32" height="32.275" viewBox="0 0 32 32.275">
            <path
              id="Subtraction_2"
              data-name="Subtraction 2"
              d="M-3762,32a15.9,15.9,0,0,1-11.314-4.686A15.9,15.9,0,0,1-3778,16a15.9,15.9,0,0,1,4.686-11.314A15.9,15.9,0,0,1-3762,0a15.9,15.9,0,0,1,11.314,4.686A15.9,15.9,0,0,1-3746,16a15.9,15.9,0,0,1-4.686,11.314A15.9,15.9,0,0,1-3762,32Zm0-29a13.015,13.015,0,0,0-13,13,13.015,13.015,0,0,0,13,13,13.015,13.015,0,0,0,13-13A13.015,13.015,0,0,0-3762,3Z"
              transform="translate(3778)"
              fill="#bde4df"
            />
            <path
              id="Subtraction_3"
              data-name="Subtraction 3"
              d="M-3743.506,41a14.952,14.952,0,0,1-10.859-4.686,16.178,16.178,0,0,1-1.23-1.443l2.06-2.146A12.384,12.384,0,0,0-3743.506,38a12.247,12.247,0,0,0,9.792-4.95l2.052,2.138c-.312.392-.643.771-.984,1.125A14.955,14.955,0,0,1-3743.506,41Z"
              transform="translate(3759.596 -8.725)"
              fill="#174842"
            />
          </svg>
        </div>

        <p className={`mx-6 ${subTitleCss} text-primary`}>{subTitle}</p>
      </div>
    </div>
  );
};

export default ProgressSection;
